import { watch, type Ref } from 'vue'

export function watchScrollFocus(trigger: Ref<boolean>) {
	let focus: Element | null = null
	let block = false

	document.addEventListener('scrollend', () => {
		if (block) {
			block = false
			return
		}

		for (const el of document.elementsFromPoint(window.innerWidth / 4, window.innerHeight / 2)) {
			if ((el.tagName === 'DIV' && el.classList.contains('row')) || el.tagName === 'TD') {
				focus = el
				break
			}
		}
	})

	watch(
		trigger,
		() => {
			if (focus) {
				block = true
				focus.scrollIntoView({
					block: 'center',
					inline: 'center',
					behavior: 'instant',
				})
			}
		},
		{ flush: 'post' },
	)
}

export function scrollToView() {
	const tableHeader = document.querySelector('table thead') || document.querySelector('table tr')

	if (tableHeader) {
		tableHeader.scrollIntoView({
			block: 'start',
			inline: 'nearest',
			behavior: 'smooth',
		})
	}
}
